import { render, staticRenderFns } from "./DiagnosticQuestionsTable.vue?vue&type=template&id=ea59cbe0&scoped=true&"
import script from "./DiagnosticQuestionsTable.vue?vue&type=script&lang=js&"
export * from "./DiagnosticQuestionsTable.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticQuestionsTable.vue?vue&type=style&index=0&id=ea59cbe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea59cbe0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VContainer,VDataTable,VIcon})
